<div class="w-full flex flex-col gap-6">
    @if (!isPracticeCreate) {
        <cdk-accordion class="flex flex-col gap-6">
            <cdk-accordion-item #practices="cdkAccordionItem" class="mt-8">
                <div
                    class="card bg-app-background-10 rounded-button shadow-sm border border-app-primary-10 overflow-hidden">
                    <button
                        class="flex justify-between items-center w-full p-6 text-app-primary-10 font-bold text-xl hover:bg-gray-50 transition-colors"
                        (click)="practices.toggle()" [attr.aria-expanded]="practices.expanded">
                        <span>Praxisliste</span>
                        <i class="fa-solid self-center text-xl"
                           [ngClass]="practices.expanded ? 'fa-angle-up' : 'fa-angle-down'"></i>
                    </button>
                    @if (practices.expanded) {
                        @for (practice of practiceList; track practice.id) {
                            <div
                                class="p-6 border-b border-app-primary-10/5"
                                role="region">
                                <div class="flex flex-col lg:flex-row justify-between w-full" [style.display]="practiceEditId === practice.id ? 'none' : ''">
                                    <div class="appointment-info flex flex-col">
                                        <div class="text-lg">{{ practice.name }}</div>
                                        <div class="text-xs">
                                            {{ practice.address.street }} {{ practice.address.houseNumber }}
                                        </div>
                                        <div class="text-xs">
                                            {{ practice.address.zipCode }} {{ practice.address.city }}
                                        </div>
                                    </div>
                                    <div class="appointment-info flex flex-col">
                                        <button class="btn primary-button mt-4"
                                                (click)="triggerPracticeEdit(practice.id)">
                                            <span>Praxis bearbeiten</span>
                                        </button>
                                        <button class="btn secondary-button mt-4" (click)="openConfirmModal(practice.id)">
                                            <span>Praxis löschen</span>
                                        </button>
                                    </div>
                                </div>
                                <div
                                    class="p-4 border-b border-app-primary-10/5"
                                    role="region" [style.display]="practiceEditId === practice.id ? '' : 'none'">
                                    <app-practice-create [practice]="practice"
                                                         (triggerPracticeEdit)="triggerPracticeEdit($event)"></app-practice-create>
                                </div>
                            </div>
                        }
                    }
                </div>
            </cdk-accordion-item>
        </cdk-accordion>
    }
    @if (isPracticeCreate) {
        <app-practice-create (triggerPracticeCreate)="triggerPracticeCreate()"></app-practice-create>
    }
</div>
<div class="flex justify-end mt-8">
    @if (!isPracticeCreate) {
        <button class="btn primary-button" (click)="triggerPracticeCreate()">
            <span>Neue Praxis anlegen</span>
        </button>
    }
</div>
